<template>
    <div
        class="md-agent-contact layout5 mg-bg"
        v-if="agent"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            backgroundColor: bgColor
        }"
    >
        <div class="agent-contact-container">
            <div class="top-container" :class="{ 'f-col': !isMobileSize }">
                <div
                    class="layout5-title-wrap"
                    :style="{
                        backgroundColor: contentBgColor
                    }"
                >
                    <site-title :title="fmtTitle" :size="40" :mbSize="24" />
                </div>
                <div class="map-img">
                    <template v-if="displayMode === 'img'">
                        <site-img type="bgImg" :src="useBgSrc" class="bgImg">
                            <div
                                class="contact-img-mask"
                                v-if="maskOption.showMask && useBgSrc"
                                :style="{ background: maskOption.maskColor }"
                            ></div>
                            <div class="default-wrap" v-if="!useBgSrc">
                                <site-img
                                    :src="defaultImgSrc"
                                    dir="width"
                                />
                            </div>
                        </site-img>
                    </template>
                    <component
                        :is="mapType"
                        v-if="loadMap && address && displayMode !== 'img'"
                        @mapLoad="mapLoad"
                        :address="address"
                        :center="center"
                        :tools="showTools"
                        :markerData="markerData"
                        :class="{
                            'search-map': true,
                            layout5: true,
                            isFullscreen: isFullscreen
                        }"
                        :useIconAddress="true"
                    />
                </div>
            </div>

            <div class="btm-container f-col">
                <div class="contact-wrap" v-animated="textAnimation">
                    <div v-if="phone" class="contact phone">
                        <div class="content-container">
                            <div class="title">
                                {{ $t('md-agent-contact.phone') }}
                            </div>
                            <p class="content">
                                <a
                                    :href="'tel:' + phone"
                                    target="_top"
                                    rel="noopener noreferrer"
                                >
                                    <span>{{ $ft.formatPhone(phone) }}</span>
                                </a>
                            </p>
                        </div>
                    </div>
                    <div v-if="email" class="contact email">
                        <div class="content-container">
                            <div class="title">
                                {{ $t('md-agent-contact.email') }}
                            </div>
                            <p class="content">
                                <a
                                    :href="'mailTo:' + email"
                                    :title="$t('common:link.mailtoTitle')"
                                    :aria-label="
                                        $t('common:link.mailtoAriaLabel', {
                                            email: email
                                        })
                                    "
                                    rel="noopener noreferrer"
                                >
                                    <span>{{ email }}</span>
                                </a>
                            </p>
                        </div>
                    </div>
                    <div
                        v-if="website && website !== ' '"
                        class="contact website"
                    >
                        <div class="content-container">
                            <div class="title">
                                {{ $t('md-agent-contact.webSiteUpper') }}
                            </div>
                            <p class="content">
                                <a
                                    :href="website"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <span>{{
                                        website.replace(/^(https?:)?\/\//, '')
                                    }}</span>
                                </a>
                            </p>
                        </div>
                    </div>
                    <div
                        v-if="address && address !== ' '"
                        class="contact address"
                    >
                        <div class="content-container">
                            <div class="title">
                                {{ $t('md-agent-contact.address') }}
                            </div>
                            <p class="content">
                                <a
                                    target="_blank"
                                    :href="
                                        'https://www.google.com.my/maps/search/' +
                                            address
                                    "
                                    v-text="address"
                                    rel="noopener noreferrer"
                                ></a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>

<script>
import { usePageStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import commonMixins from '../index';
import mapMixins from '../map.mixin';
import { defineAsyncComponent } from 'vue';
export default {
    mixins: [commonMixins, mapMixins],
    components: {
        Map: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map_broker"*/ '@/components/map/broker.vue'
            )),
        hereMap: defineAsyncComponent(() =>
            import(
                /* webpackChunkName: "map-here_broker"*/ '@/components/map-here/broker.vue'
            ))
    },
    data: function() {
        return {
            mapTools: [
                {
                    name: 'zoom',
                    css: 'right: 20px; bottom: 20px; width:40px; height: 80px; color:#191919;'
                },
                {
                    name: 'maptype',
                    css: 'left: 20px; bottom: 20px; border: 0',
                    icon: 'icon-a-Zoominandout'
                },
                {
                    name: 'fullscreen',
                    css: 'width: 40px; height: 40px; right: 20px; top: 20px; box-shadow: 0 10px 15px 0 rgba(170, 186, 218, 0.3); color: #191919; border-radius: 4px;line-height: 40px; font-size: 18px;',
                    icon: 'icon-a-fullscreen'
                }
            ],
            mobileMapTools: [
                {
                    name: 'zoom',
                    css: 'right: 15px; bottom: 80px; width: 40px; height: 80px; border-radius: 4px; box-shadow: unset; color:#191919'
                },
                {
                    name: 'mobileMaptype',
                    css: 'right: 15px; bottom: 15px; box-shadow: unset; border-radius: 4px; color:#191919;'
                }
            ],
            centerPoint: ''
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            mapType: store =>
                store.page?.map?.type === 'google' ? 'Map' : 'hereMap'
        })
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-agent-contact.layout5 {
    .top-container {
        height: 340px;
        display: flex;
        gap: 15px;
        .layout5-title-wrap {
            width: 30%;
            padding: 30px;
            background: var(--g-btn-background);
            display: flex;
            justify-content: center;
            align-items: center;
            .site-title {
                color: #fff;
            }
        }
        .map-img {
            flex: 1;
        }
    }
    .bgImg {
        height: 100%;
        position: relative;
        .contact-img-mask {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
        }
    }
    .default-wrap {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(218, 218, 218, 0.2);
        img {
            width: 64px;
            height: 56px;
            object-fit: contain;
            opacity: 0.3;
        }
    }

    .site-map {
        height: 100%;

        .zoom-out:before {
            content: none !important; //zoom Remove pseudo elements
        }
        .zoom.standard .zoom-out:after,
        .zoom.standard .zoom-in:after,
        .zoom.standard .zoom-in:before {
            background-color: #191919;
        }
        .map-type {
            img {
                width: 50px !important;
                height: 50px !important;
                border-radius: 5px;
            }
            p {
                font-size: 12px;
            }
            .iconfont.icon-a-Zoominandout {
                width: 50px;
                height: 50px;
                line-height: 50px;
                &:before {
                    font-size: 42px;
                    line-height: 50px;
                }
            }
            
        }
        .zoom.standard,
        .iconfont.icon-a-fullscreen{
            display: none;
        }
        .gm-fullscreen-control {
            top: 10px !important;
            right: 10px !important;
        }
        .gm-bundled-control .gm-control-active {
            right: 10px;
        }
    }

    .btm-container {
        margin-top: 30px;
        .contact-wrap {
            .contact {
                padding: 20px 0;
                width: 100%;
                border-bottom: 1px solid rgba(218, 218, 218, 0.5);
                display: flex;
                align-items: center;
                position: relative;
                &::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 0%;
                    height: 100%;
                    background-color: rgba(25, 25, 25, 0.05);
                    z-index: -1;
                    transition: width 0.4s ease;
                    cursor: pointer;
                }
                &:hover::before {
                    width: 100%;
                }
                .content-container {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    gap: 15px;
                }
                .title {
                    width: 30%;
                    font-family: var(--font-normal);
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 150%;
                    text-align: center;
                    vertical-align: middle;
                    color: var(--g-text-color);
                }
                .content {
                    font-family: var(--font-medium);
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 150%;
                    color: var(--g-primary-color);
                    text-decoration: none;
                    text-align: left;
                    position: relative;
                    transition: 0.3s ease;
                    &:before,
                    &:after {
                        content: '';
                        display: block;
                        width: 0;
                        height: 1px;
                        background: var(--g-primary-color);
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        transition: 0.3s ease;
                    }
                    &:before {
                        width: 100%;
                        opacity: 0.5;
                    }
                    &:hover:after {
                        width: 100%;
                    }
                }
                &.address {
                    .content {
                        &:before,
                        &:after {
                            display: none;
                        }
                    }
                }
            }
        }
    }
}
@include media-800 {
    .md-agent-contact.layout5 {
        .top-container {
            height: auto;
            display: block;
            .layout5-title-wrap {
                width: 100%;
                padding: 15px;
            }
            .map-img {
                flex: none;
                width: 100%;
                height: 408px;
            }
        }
        .bgImg {
            height: 408px;
        }
        .btm-container {
            margin-top: 20px;
            .contact-wrap {
                .contact {
                    padding: 20px 0 10px 0;
                    .title {
                        width: 24%;
                        text-align: left;
                    }
                    .content {
                        flex: 1;
                        &:before,
                        &:after {
                            content: none;
                        }
                        a {
                            text-decoration: underline;
                        }
                    }
                }
            }
        }
    }
}
</style>
